(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dual-product-slider"] && !Shopify.designMode) return;
  try {
    
  class DualProductSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-dps-track]');
      this.tabs = Array.from(this.querySelectorAll('[data-dps-tab]'));
      this.dots = Array.from(this.querySelectorAll('[data-dps-dot]'));
      this.slides = Array.from(this.querySelectorAll('[data-dps-slide]'));

      if (!this.track || this.slides.length < 2) return;

      this.tabs.forEach((tab) => tab.addEventListener('click', this.#onControlClick.bind(this)));
      this.dots.forEach((dot) => dot.addEventListener('click', this.#onControlClick.bind(this)));

      this.#observe();
    }

    #onControlClick(event) {
      const id = event.currentTarget.dataset.target;
      const target = id ? this.querySelector('#' + CSS.escape(id)) : null;
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }

    #observe() {
      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              const index = Number(entry.target.dataset.index);
              this.#setActive(index);
            }
          }
        },
        { root: this.track, threshold: [0.6] }
      );

      this.slides.forEach((slide) => observer.observe(slide));
      this.observer = observer;
    }

    #setActive(index) {
      const slide = this.slides[index];
      const slideId = slide?.id;
      this.tabs.forEach((tab) => {
        const active = slideId ? tab.dataset.target === slideId : false;
        tab.setAttribute('aria-selected', active);
        tab.tabIndex = active ? 0 : -1;
      });
      this.dots.forEach((dot, i) => {
        const active = i === index;
        dot.setAttribute('aria-selected', active);
        dot.tabIndex = active ? 0 : -1;
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('dual-product-slider')) {
    customElements.define('dual-product-slider', DualProductSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog.header__drawer');
      this.openButton = this.querySelector('[data-drawer-open]');
      this.closeButton = this.querySelector('[data-drawer-close]');

      this.openButton?.addEventListener('click', this.#open.bind(this));
      this.closeButton?.addEventListener('click', this.#close.bind(this));
      this.dialog?.addEventListener('click', this.#handleBackdropClick.bind(this));
      this.dialog?.addEventListener('close', this.#handleClose.bind(this));
    }

    #open() {
      if (!this.dialog) return;
      this.dialog.showModal();
      this.openButton?.setAttribute('aria-expanded', 'true');
    }

    #close() {
      this.dialog?.close();
    }

    #handleBackdropClick(event) {
      if (event.target === this.dialog) this.#close();
    }

    #handleClose() {
      this.openButton?.setAttribute('aria-expanded', 'false');
      this.openButton?.focus();
    }
  }

  if (!customElements.get('header-drawer')) {
    customElements.define('header-drawer', HeaderDrawer);
  }

  } catch(e) { console.error(e); }
})();
})();
